import { useSelector, useDispatch } from "react-redux";
import { setCategory } from "../features/filter/filterSlice";
import { useTranslation } from "react-i18next";
import { FiFilter, FiChevronDown } from "react-icons/fi";

function CategoriesList() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const {
    items: categories = [],
    loading,
    error,
  } = useSelector((state) => state.categories);

  const selectedCategory =
    useSelector((state) => state.filter.category) || "all";

  const { items: products = [] } = useSelector((state) => state.products);

  const isArabic = i18n.language === "ar";

  if (loading) {
    return (
      <div
        className="d-flex align-items-center gap-2"
        style={{
          height: "48px",
          color: "#999",
          fontSize: "13px",
        }}
      >
        <span
          className="spinner-border spinner-border-sm"
          style={{
            color: "#B5183F",
          }}
        />

        {isArabic ? "جاري تحميل التصنيفات..." : "Loading categories..."}
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="d-flex align-items-center"
        style={{
          height: "48px",
          color: "#B5183F",
          fontSize: "13px",
        }}
      >
        {isArabic ? "حدث خطأ في تحميل التصنيفات" : "Failed to load categories"}
      </div>
    );
  }

  const getCategoryCount = (categoryId) => {
    return products.filter(
      (product) => Number(product.category_id) === Number(categoryId),
    ).length;
  };

  return (
    <div
      className="d-flex  align-items-center gap-2"
      style={{
        width: "100%",
      }}
    >
      {/* Filter Icon */}

      <div
        className="d-flex align-items-center justify-content-center rounded-3"
        style={{
          width: "42px",
          height: "42px",
          flexShrink: 0,
          backgroundColor: "#F9E9EE",
          color: "#B5183F",
        }}
      >
        <FiFilter size={17} />
      </div>

      {/* Select */}

      <div
        className="position-relative flex-grow-1"
        style={{
          maxWidth: "100%",
        }}
      >
        <select
          className="form-select rounded-3"
          value={selectedCategory}
          onChange={(e) => dispatch(setCategory(e.target.value))}
          style={{
            height: "48px",
            width: "100%",
            backgroundColor: "#FDFBFC",
            border: "1px solid #EEE5E8",
            color: "#444",
            fontSize: "15px",
            fontWeight: 600,
            boxShadow: "none",
            cursor: "pointer",
            appearance: "none",
            WebkitAppearance: "none",
            MozAppearance: "none",
            backgroundImage: "none",
            paddingLeft: isArabic ? "12px" : "15px",
            paddingRight: isArabic ? "15px" : "12px",
          }}
        >
          <option value="all">
            {isArabic
              ? `كل المنتجات (${products.length})`
              : `All Products (${products.length})`}
          </option>

          {categories.map((cat) => {
            const count = getCategoryCount(cat.id);

            const categoryName = isArabic ? cat.name_ar : cat.name_en;

            return (
              <option key={cat.id} value={cat.id}>
                {categoryName} ({count})
              </option>
            );
          })}
        </select>

        <FiChevronDown
          className={`position-absolute top-50 translate-middle-y ${
            isArabic ? "start-0 ms-3" : "end-0 me-3"
          }`}
          size={16}
          style={{
            color: "#B5183F",
            pointerEvents: "none",
          }}
        />
      </div>
    </div>
  );
}

export default CategoriesList;
